export default {
  links: [
    {
      rel: 'masterdata',
      href: '/masterdata/v1/index',
    },
  ],
}
